import * as React from 'react';
import { SVGProps } from 'react';

function SvgMoreHorizontal(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      data-name="more (horizontal)"
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}>
      <path fill="none" d="M0 0h24v24H0z" />
      <path
        data-name="\u21B3Color"
        d="M18 14a2 2 0 1 1 2-2 2 2 0 0 1-2 2Zm-6 0a2 2 0 1 1 2-2 2 2 0 0 1-2 2Zm-6 0a2 2 0 1 1 2-2 2 2 0 0 1-2 2Z"
      />
    </svg>
  );
}

export default SvgMoreHorizontal;
